// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    // suggestionPosition: 'left'
  },
};
(function () {
  BoostPFS.inject(this);
  InstantSearchResult.prototype._applyFilterAutocompleteAppendElement =
    function () {
      this.appendToSelector = ".search-btn-expanded";
    };
  // Customize style of Suggestion box
  // * hacky way of overriding the top CSS property
  SearchInput.prototype.customizeInstantSearch = function () {
    const [suggestionElement] = this.£uiMenuElement;
    const [searchElement] = this.£element;
    const searchBoxId = this.id;
    //     const carousel = document.getElementById('shopify-section-header-carousel')
    //     const header = document.getElementById('shopify-section-header')
    //     const searchWrapper = suggestionElement.parentElement
    //     if (!suggestionElement || !searchElement || !carousel || !header || !searchWrapper) return
    // 	// Need to calc height
    //     const isCarouselVisible = window.scrollY <= carousel.clientHeight
    //     const totalHeaderHeight = (isCarouselVisible ? carousel.clientHeight : 0) + header.clientHeight + searchElement.clientHeight
    //     if (!totalHeaderHeight) return
    // 	const offsetHeight = totalHeaderHeight + window.scrollY
    //     searchWrapper.style.top = `£{offsetHeight}px`
  };
  InstantSearchApi.beforeCall = function () {
    Globals.instantSearchQueryParams.sort = "price-descending";
  };
})();
